import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderBarComponent } from '@app/core/components/header-bar/header-bar.component';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
import { CounterLessAddHomeComponent } from '@app/shared/components/counter-less-add-home/counter-less-add.home.component';
import { ToastrService } from 'ngx-toastr';
import { AddCartCommand } from '../../command/add-cart-command';
import { IndividualGuideCommand } from '../../command/individual-guide.command';
import { HomeServiceService } from '../../services/home-service.service';
import { GenericDialog } from '../../../../shared/models/generic-dialog.model';
import { GenericDialogComponent } from '../../../../shared/components/generic-dialog/generic-dialog.component';
import { GenericAlertChangeAccount } from '../../../../shared/models/generic-alert-change-account.model';
import { ModalConfirmAlertChangeAccountComponent } from '../../../../shared/components/modal-alert-change-account/modal-alert-change-account.component';
import { AppConfigurationService } from '@app/core/services/app-configuration.service';
const logger = new LoggerService('HomepagePage');

@Component({
  selector: 'dhl-homepage',
  templateUrl: './homepage.page.html',
  styleUrls: ['./homepage.page.scss']
})
export class HomepagePage implements OnInit {
  constructor(
    public dialog: MatDialog,
    public fb: FormBuilder,
    public toastrService: ToastrService,
    public homeservice: HomeServiceService,
    public snackBar: MatSnackBar,
    public headerComponent: HeaderBarComponent,
    public storage: SaveObjectInLocalServiceService,
    public appconfigurationservice: AppConfigurationService
  ) {}

  ngOnInit() {
    if (this.storage.getObject('afterPayment') === 'true') {
      logger.info('Colocando en 0 el carrito');
      this.headerComponent.setNumberProductsFromCart(0);
      logger.info('Eliminando valor del storage');
      this.storage.removeObject('afterPayment');
    }
    this.callServiceGetAllGuidePacks();
    this.callServiceGetIndividualGuide();
  }

  public guidePacks: any = [];
  public individualGuide: any = [];
  addToCartDisable = false;

  callServiceGetAllGuidePacks() {
    this.homeservice.getAllGuidePacks().subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          this.guidePacks = response.data;
        }
      },
      error: (e) => {
        logger.error(e);
      },
      complete: () => {
        logger.info('callServiceGetAllGuidePacks process complete');
      }
    });
  }

  callServiceIndividualGuidesOriginEvent(event: boolean) {
    if (event) {
      this.callServiceGetIndividualGuide();
    }
  }

  @ViewChildren(CounterLessAddHomeComponent) componentesCounter!: QueryList<CounterLessAddHomeComponent>;

  callServiceGetIndividualGuide() {
    const inputIndividualGuide = document.getElementById('quantityguinnn') as HTMLInputElement;
    const individualGuideCommand: IndividualGuideCommand = {
      GuidesNumber: Number(inputIndividualGuide.value)
    };

    this.homeservice.getIndividialGuide(individualGuideCommand).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          this.individualGuide = response.data[0];
        }
      },
      error: (e) => {
        logger.error(e);
      },
      complete: () => {
        logger.info('callServiceGetIndividualGuide process complete');
      }
    });
  }

  showModalChangeAccountMsg() {

    const fechaCambio = this.appconfigurationservice.config.changeAccountEffectiveDate;

    const dataForModalRedirectoChangeAccount: GenericAlertChangeAccount = {
    title: '🔔 ¡Aviso importante sobre los pagos por transferencia bancaria!',
    message:
      `A partir del <strong> ${fechaCambio} </strong>, los pagos por transferencia deberán realizarse únicamente a nuestra <strong> nueva cuenta bancaria </strong>. </br>
     ⚠️ <strong>La cuenta anterior dejará de estar operativa y no podrá recibir pagos</strong>.</br></br>
     Por favor, asegúrate de actualizar los datos en tus sistemas o procesos de pago para evitar inconvenientes.</br></br>
     👉 Puedes consultar los nuevos datos bancarios en tu correo electrónico al momento de generar una orden de compra mediante la modalidad de pago con transferencia.</br></br>
     Gracias por tu atención y confianza.</br></br>
     --El equipo de Prepago`,
    acceptLabel: '',
    showAccept: false,
    showCancel: false
    // image: './assets/images/login/ic_alert.png',
  };
   this.openModalChangeAccountMsg(dataForModalRedirectoChangeAccount);
 }

  @ViewChildren(CounterLessAddHomeComponent) countersComponent!: QueryList<CounterLessAddHomeComponent>;

  addToCart(type: string, packages: any, identificatorButton: string, counterComponent: string) {
    const btn = document.getElementById(identificatorButton) as HTMLInputElement;
    let inputQuiantity: HTMLInputElement | undefined | null;

    if (packages != null) {
      inputQuiantity = document.getElementById(this.getInputId(packages)) as HTMLInputElement;
    }

    const inputIndividualGuide = document.getElementById('quantityguinnn') as HTMLInputElement;
    const counterComp = this.countersComponent.find((ch) => ch.identificador === counterComponent);
    const addToCartCommand: AddCartCommand = {
      IndividualGuideId: type.includes('guide') ? this.individualGuide.individualGuideId : null,
      GuidesPackageId: type.includes('packages') ? packages.idGuidePackage : null,
      Quantity: type.includes('packages') ? Number(inputQuiantity?.value) : Number(inputIndividualGuide.value),
      GuidesNumber: type.includes('guide') ? Number(inputIndividualGuide.value) : packages.guidesNumber,
      Name: type.includes('packages') ? packages.name : '',
      UnitPrice: type.includes('guide') ? this.individualGuide.unitPrice : 0.0
    };

    this.homeservice.addProductToCart(addToCartCommand).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          btn.classList.add('btn-add-to-cart-ok');
          btn.disabled = true;
          btn.innerHTML = 'Agregado';
          // counterComp?.resetInput();
          // Es decir agregamos paquetes
          // Regresamos a 1
          if (packages != null) {
            inputQuiantity = document.getElementById(this.getInputId(packages)) as HTMLInputElement;
            inputQuiantity.value = '1';
          } else {
            // Es decir agregamos guias individuales
            inputIndividualGuide.value = '1';
          }
          this.storage.setObject('itemsCart', response.data.length);
          this.headerComponent.setNumberProductsFromCart(this.storage.getObject('itemsCart'));

          this.validateQuantityAndMsgProduct(response.data);

          setTimeout(() => {
            btn.classList.remove('btn-add-to-cart-ok');
            btn.disabled = false;
            btn.innerHTML = 'Agregar al carrito';
          }, 3000);
        }
      },
      error: (e) => {
        logger.error(e);
      },
      complete: () => {
        logger.info('addToCart process complete');
      }
    });
  }

  validateQuantityAndMsgProduct(data: any) {
    if (data[0].msgRule != null) {
      if (data[0].msgRule != '' && data[0].msgRule != null) {
        this.snackBar.open(data[0].msgRule);
      }
    }
    if (data.length > 1) {
      if (data[1].msgRule != null) {
        if (data[1].msgRule != '' && data[1].msgRule != null) {
          this.snackBar.open(data[1].msgRule);
        }
      }
    }
  }

  cambiarValorInput(identificadorInput: string, valor: string) {
    const input = document.querySelector(identificadorInput) as HTMLInputElement;
    input.value = valor;
  }

  getInputId(pkg: any): string {
    // const searchRegExp = /%/g;
    // return name.split(' ').join('').replace(searchRegExp, '');
    return `pkg-${pkg.idGuidePackage}`;

  }

  openModalChangeAccountMsg(dataDialog: GenericAlertChangeAccount): void {
    this.dialog.open(ModalConfirmAlertChangeAccountComponent, { panelClass: 'dhl-content-change-account', data: dataDialog});
  }
}
